// extracted by mini-css-extract-plugin
export default {"tooltip":"_o-z","sharingV2":"ap-z","sharingIconsV2":"bp-z","links":"cp-z","link":"dp-z","facebookV2":"ep-z","twitterV2":"fp-z","pinterestV2":"gp-z"};